/* global wx */
/* global URL_BASE */
/* global WEIXIN_APPID */
/* global WeixinJSBridge */
import rawRequest from '@/utils/raw-request'
import env from '@/utils/env'

const jsApiList = [
  'checkJsApi',
  'onMenuShareTimeline',
  'onMenuShareAppMessage',
  'onMenuShareQQ',
  'onMenuShareQZone',
  'startRecord',
  'stopRecord',
  'translateVoice',
  'hideOptionMenu',
  'hideMenuItems',
  'playVoice',
  'uploadVoice',
  'downloadVoice',
  'onVoicePlayEnd',
  'getLocation',
  'openLocation',
  'chooseWXPay',
  'closeWindow',
  'updateAppMessageShareData',
  'updateTimelineShareData',
  'scanQRCode'
]

const openTagList = ['wx-open-launch-weapp'];

let _ready = false
let _query = []

if (typeof WeixinJSBridge == 'undefined') {
  if (document.addEventListener) {
    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
  }
} else {
  onBridgeReady()
}

function onBridgeReady() {
  console.info('onBridgeReady')

  _ready = config();
}

function config() {
  return new Promise((resolve, reject) => {
    if (env.isWeixin) {
      rawRequest({
        url: `${URL_BASE.H5}/hangban/vue/api/wechat/config`,
        data: {
          appid: WEIXIN_APPID,
          url: location.href.split('#')[0]
        }
      }).then(r => {
        let opts = r.body
        opts.debug = false
        opts.jsApiList = jsApiList
        opts.openTagList = openTagList

        //微信配置
        wx.config(opts)

        //微信配置失败
        wx.error((res) => {
          console.error('微信配置失败', res)
          reject(false)
        })

        //微信准备完毕
        wx.ready(() => {
          console.info('微信配置成功')

          while (_query && _query.length > 0) {
            let task = _query.pop()

            if (task) {
              task()
            }
          }

          resolve(true)
        })
      }).catch(() => {
        reject(false)
      })
    } else {
      reject(false)
    }
  })
}

function taskFactory(fun) {
  if (env.isWeixin) {
    if (_ready) {
      _ready.then(fun)
    } else {
      _query.push(fun)
    }
  }
}

//分享
function share(params) {
  taskFactory(() => {
    wx.onMenuShareTimeline(params)
    wx.onMenuShareAppMessage(params)
    wx.onMenuShareQQ(params)
    wx.onMenuShareQZone(params)
  })
}

//获取定位
function getLocation(params) {
  taskFactory(() => {
    wx.getLocation(params)
  })
}

//扫码
function scanQRCode(params) {
  taskFactory(() => {
    wx.scanQRCode(params)
  })
}
function hideMenuItems( params ) {
  taskFactory(() => {
    wx.hideMenuItems(params)
  })
}

export default {
  share,
  getLocation,
  scanQRCode,
  hideMenuItems
}



// WEBPACK FOOTER //
// ./src/utils/weixinApi.js